export class FixedStepLoop {
  constructor({ stepHz, update, render, getStepScale = () => 1 }) {
    this.stepMs = 1000 / stepHz;
    this.maxCatchUpSteps = 5;
    this.update = update;
    this.render = render;
    this.getStepScale = getStepScale;
    this.running = false;
    this.accumulator = 0;
    this.lastTime = 0;
    this.frame = this.frame.bind(this);
  }

  start() {
    if (this.running) {
      return;
    }
    this.running = true;
    this.lastTime = performance.now();
    requestAnimationFrame(this.frame);
  }

  stop() {
    this.running = false;
  }

  frame(now) {
    if (!this.running) {
      return;
    }
    const delta = Math.min(100, now - this.lastTime);
    this.lastTime = now;
    const scaledDelta = delta * Math.max(0, this.getStepScale());
    this.accumulator = Math.min(this.accumulator + scaledDelta, this.stepMs * this.maxCatchUpSteps);
    let steps = 0;
    while (this.accumulator >= this.stepMs && steps < this.maxCatchUpSteps) {
      this.update();
      this.accumulator -= this.stepMs;
      steps += 1;
    }
    this.render(delta);
    requestAnimationFrame(this.frame);
  }
}
